import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ErrorHandlingService } from '../services/error-handling.service';
import { ProcessedError } from '../models';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private errorHandlingService: ErrorHandlingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => { // Captura cualquier error en la respuesta Http
        let processedError:ProcessedError; // Almacena el error procesado

        const rawMessage = (typeof error.error === 'string' ? error.error : undefined) ??
        error.error?.Error ??
        error.error?.detail ??
        error.error?.errorMessage ??
        error.error?.message;

        // Construir el mensaje de acuerdo al tipo de error
        const message: string = rawMessage ??
        (error.error ? JSON.stringify(error.error) : undefined) ??
        error.message ??
        'Error desconocido';

        if (error.error instanceof ErrorEvent) { // Verifica si es un error del lado del cliente
          processedError = this.errorHandlingService.getError(400, message);
        } else { // Asume que es un error del lado del servidor
          processedError = this.errorHandlingService.getError(error.status, message);
        }

        console.error('Error interceptado:', processedError);
        return throwError(() => processedError); // Devuelve un observable con el error procesado para ser manejado donde se requiera
      })
    );
  }
}
